import * as React from "react";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { LoginPage } from "@/pages/login";
import { InvitationAcceptPage } from "@/pages/invitation-accept";

export const authRoutes: FeatureRouteModule = {
  publicRoutes: [
    { path: "login", handle: { title: "Log in" }, element: React.createElement(LoginPage) },
    {
      path: "invitations/:token",
      handle: { title: "Accept invitation" },
      element: React.createElement(InvitationAcceptPage),
    },
  ],
  shellRouteDefs: [
    {
      path: "/search",
      title: "Search",
      summary: "Project search is not connected yet. It needs a search index.",
    },
  ],
};

export const authNav: FeatureNavModule = {};
